// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".projectsRadioButton[data-v-51fc64d3] .customRadio + label {\n  padding: 7px 20px;\n}", ""]);
// Exports
module.exports = exports;
